import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

import {
  PUBLIC_PAGE_MENU_LOCATIONS,
  PublicPageMenuLocation,
} from 'src/helpers/publicPageMenuLocations';

interface Props {
  value: PublicPageMenuLocation[];
  onChange: (locations: PublicPageMenuLocation[]) => void;
}

export default function MenuLocationsSelect({ value, onChange }: Props) {
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<PublicPageMenuLocation[]>) => {
    const raw = event.target.value;
    const next = (typeof raw === 'string' ? raw.split(',') : raw) as PublicPageMenuLocation[];
    onChange(next);
  };

  const labelFor = (loc: PublicPageMenuLocation) =>
    loc === 'top' ? t('system.pages.menuLocationTop') : t('system.pages.menuLocationFooter');

  return (
    <FormControl fullWidth margin="normal">
      <InputLabel id="menu-locations-label">{t('system.pages.menuLocations')}</InputLabel>
      <Select
        labelId="menu-locations-label"
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label={t('system.pages.menuLocations')} />}
        renderValue={selected => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map(loc => (
              <Chip key={loc} label={labelFor(loc)} size="small" />
            ))}
          </Box>
        )}
        MenuProps={{
          slotProps: {
            paper: {
              style: { maxHeight: 48 * 4.5 + 8 },
            },
          },
        }}
      >
        {PUBLIC_PAGE_MENU_LOCATIONS.map(loc => (
          <MenuItem key={loc} value={loc}>
            {labelFor(loc)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
